import { render, staticRenderFns } from "./PolygonShape.vue?vue&type=template&id=d9cdfd4e&scoped=true"
import script from "./PolygonShape.vue?vue&type=script&lang=js"
export * from "./PolygonShape.vue?vue&type=script&lang=js"
import style0 from "./PolygonShape.vue?vue&type=style&index=0&id=d9cdfd4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9cdfd4e",
  null
  
)

export default component.exports